<template>
  <div v-if="showTip">
    <div class="fixed text-sm left-2/4 flex flex-row justify-between items-center z-10 schedule-tip">
      <HintOutline :size="18" color="#017AFF" class="warning-icon" />
      <template v-if="isChrome">
        {{ $t('layout.common.index.fl6dkf') }}
      </template>
      <template v-else>
        {{ $t('layout.common.index.a583sz') }}
      </template>
      <a class="download-btn" name="file" :href="downloadLink" target="_blank">点击下载</a>
      <CloseOutline
        v-if="!isNewCustomerList || !isChrome"
        :size="18"
        color="#b3b3b3"
        class="close-icon"
        @click="handleClose" />
    </div>
  </div>
</template>

<script>
import { defineComponent, reactive, toRefs, computed, ref } from '@vue/composition-api'

import { CloseOutline, HintOutline } from 'okki-vue-icon'
import { useLocalStorage } from '@shared/use/use-storage'
import { useWindowEvent } from '@/use'

const DOWNLOAD_LINK = 'https://www.google.cn/chrome/'

// 关闭检测下载谷歌浏览器提示
const CLOSE_CHROME_TIP = 'CLOSE_CHROME_TIP'

export default defineComponent({
  components: {
    CloseOutline,
    HintOutline,
  },
  setup() {
    const { value: closeChromeTip, setItem } = useLocalStorage(CLOSE_CHROME_TIP, true)
    const state = reactive({
      isChrome: !!(navigator.userAgent.indexOf('Chrome') > -1),
      isLowChrome:
        Number(
          navigator.userAgent
            ?.toLocaleLowerCase()
            ?.match(/chrome\/([\d.]+)/)?.[1]
            ?.split('.')?.[0],
        ) < 64,
      pathname: '',
      downloadLink: DOWNLOAD_LINK,
    })

    const isNewCustomerList = computed(() => {
      return state.pathname.includes('crm/customer/list')
    })

    const showTip = computed(() => {
      return (
        (closeChromeTip.value && (!state.isChrome || state.isLowChrome)) ||
        (state.isChrome && isNewCustomerList.value && state.isLowChrome)
      )
    })
    const handleClose = () => {
      setItem(false)
    }

    useWindowEvent(
      'single-spa:before-routing-event',
      () => {
        state.pathname = location.pathname
      },
      {
        immediate: true,
      },
    )
    return {
      ...toRefs(state),
      closeChromeTip,
      handleClose,
      isNewCustomerList,
      showTip,
    }
  },
})
</script>

<style>
.chrome-tip-alert {
  top: 66px;
}
</style>
